import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, Select, notification} from 'antd';

import {addRegulatoryReportingType} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";

const Option = Select.Option;
const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddRegulatoryReportingTypeForm extends Component {
  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addRegulatoryReportingType(values);
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Add Regulatory Reporting Type">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required',
                min: 2,
                max: 30
              }]
            })(
              <Input autoFocus />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Unit Of Measure Class"
          >
            {getFieldDecorator('unitOfMeasureClass', {
              rules: [{
                required: true,
                message: 'Unit Of Measure Class is required'
              }]
            })(
              <Select>
                <Option key="each" value="each">Each</Option>
                <Option key="weight" value="weight">Weight</Option>
                <Option key="volume" value="volume">Volume</Option>
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Regulatory Reporting Type
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddRegulatoryReportingTypeForm.propTypes = {
  history: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  addRegulatoryReportingType: PropTypes.func.isRequired
};

const AddRegulatoryReportingTypePage = Form.create()(AddRegulatoryReportingTypeForm);

const mapStateToProps = state => ({
  loading: state.regulatoryReportingType.addingRegulatoryReportingType,
});

const mapDispatchToProps = dispatch => ({
  addRegulatoryReportingType: payload => (dispatch(addRegulatoryReportingType(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddRegulatoryReportingTypePage);



// WEBPACK FOOTER //
// ./src/RegulatoryReporting/AddRegulatoryReportingTypePage.js